{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Расширение Chrome не установлено.",
      "CTA": "Установить расширение"
    },
    "TABS": {
      "PHONE": "Телефон",
      "SMS": "SMS",
      "HISTORY": "История"
    },
    "HISTORY": {
      "OPEN": "Открыт",
      "RECENT": "Недавние",
      "MISSED": "Пропущенные",
      "LOADING": "Загружаем звонки...",
      "EMPTY": "Нет звонков",
      "ERROR": "Не удалось загрузить звонки",
      "CALL": "Перезвонить",
      "CALL_STATUS": {
        "BUTTON": "Установить статус звонка",
        "TITLE": "Статус звонка",
        "SEARCH_PLACEHOLDER": "Поиск статусов...",
        "LOADING": "Загружаем статусы...",
        "NO_OPTIONS": "Статусы звонков не настроены",
        "NO_MATCH": "Статусы не найдены",
        "OPTIONS_ERROR": "Не удалось загрузить статусы",
        "RETRY": "Повторить попытку",
        "CONFIRM_QUESTION": "Установить статус «{status}» и завершить беседу?",
        "CONFIRM": "Подтвердить",
        "BACK": "Назад",
        "CANCEL": "Отменить",
        "SAVING": "Сохранение...",
        "SAVE_ERROR": "Не удалось сохранить статус",
        "RESOLVE_ERROR": "Статус сохранён, но не удалось завершить беседу"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Номер телефона, напр. +421903000000",
      "BODY_PLACEHOLDER": "Напишите сообщение...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Отправить SMS",
      "SENDING": "Отправка...",
      "SENT": "SMS отправлено",
      "LOADING": "Загрузка SMS-источников...",
      "NO_INBOX": "У этого аккаунта нет SMS-источника, поэтому SMS отправить нельзя.",
      "INVALID_NUMBER": "Введите номер в международном формате, включая + в начале.",
      "ERROR": "Не удалось отправить SMS. Попробуйте ещё раз."
    },
    "ACTIONS": {
      "CONNECT": "Подключиться",
      "GO_TO_TAB": "Перейти на эту вкладку",
      "DISCONNECT": "Отключиться",
      "ANSWER": "Ответить",
      "HANGUP": "Завершить звонок",
      "HOLD": "Удержание",
      "MUTE": "Выключить микрофон",
      "SILENCE": "Выключить звук",
      "TRANSFER": "Перевести",
      "COMPLETE_TRANSFER": "Завершить перевод",
      "RETURN_TO_CALLER": "Вернуться к звонящему",
      "CANCEL_TRANSFER": "Отменить перевод",
      "DIALPAD": "Показать клавиатуру",
      "OPEN_CONVERSATION": "Открыть диалог"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Входящий звонок",
      "INCOMING_CALL_FROM": "Входящий звонок от {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Входящий звонок с номера {number}",
      "ANSWER": "Ответить",
      "DECLINE": "Отклонить"
    },
    "TRANSFER": {
      "TITLE": "Перевод звонка",
      "PLACEHOLDER": "Введите номер для перевода...",
      "SEARCH_PLACEHOLDER": "Поиск операторов...",
      "TARGET_PLACEHOLDER": "Выбранный получатель перевода",
      "CONFIRM": "Перевести",
      "MODE_DIRECT": "Перевести сейчас",
      "MODE_CONSULT": "Сначала позвонить оператору",
      "CANCEL": "Отменить"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Вы уверены, что хотите уйти на перерыв во всех очередях?",
      "CONFIRM_READY": "Вы уверены, что хотите вернуться в статус готовности во всех очередях?",
      "CONFIRM_BREAK_QUEUE": "Вы уверены, что хотите выйти из очереди {queue}?",
      "CONFIRM_READY_QUEUE": "Вы уверены, что хотите войти в очередь {queue}?",
      "LOGIN_TO_QUEUE": "Войти",
      "LOGOUT_FROM_QUEUE": "Выйти",
      "LOGIN_TO_ALL_QUEUES": "Войти во все очереди",
      "LOGOUT_FROM_ALL_QUEUES": "Выйти из всех очередей",
      "OPTION_LOGOUT": "Выйти",
      "OPTION_BREAK": "Перерыв",
      "OPTION_LUNCH": "Обед",
      "OPTION_AWAY": "Отошёл",
      "OPTION_DO_NOT_DISTURB": "Не беспокоить",
      "OPTION_BUSINESS_TRIP": "Командировка",
      "CONFIRM": "Подтвердить",
      "CANCEL": "Отменить"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Нет соединения с телефонной системой",
      "MESSAGE": "Похоже, ваше интернет-соединение не работает. Проверьте его и повторите попытку.",
      "CREDENTIALS_TITLE": "Телефонная система отклонила ваши учётные данные",
      "CREDENTIALS_MESSAGE": "Телефонная система отклонила имя пользователя или пароль, сохранённые в вашем профиле. Проверьте их в Настройках профиля или обратитесь к администратору.",
      "CONFIGURATION_TITLE": "Настройки телефона недействительны",
      "CONFIGURATION_MESSAGE": "Имя пользователя SIP или адрес сервера имеют неверный формат, поэтому телефон не может подключиться. Исправьте это в Настройках профиля.",
      "NETWORK_SHORT": "Нет соединения",
      "CREDENTIALS_SHORT": "Учётные данные отклонены",
      "CONFIGURATION_SHORT": "Неверные настройки телефона",
      "RETRY": "Повторить попытку",
      "DISMISS": "Отменить"
    },
    "CONNECTION_QUALITY": "Качество соединения",
    "CONNECTION_QUALITY_EXCELLENT": "Отличное",
    "CONNECTION_QUALITY_GOOD": "Хорошее",
    "CONNECTION_QUALITY_FAIR": "Удовлетворительное",
    "CONNECTION_QUALITY_POOR": "Плохое",
    "CONNECTION_QUALITY_DISCONNECTED": "Нет соединения",
    "STATUS": {
      "OFFLINE": "Телефон офлайн",
      "IN_OTHER_TAB": "Телефон подключён в другой вкладке",
      "CONNECTING": "Подключение...",
      "DISCONNECTING": "Отключение...",
      "ONLINE": "Телефон онлайн",
      "DIALING": "Набор номера",
      "TRANSFERRING": "Перевод звонка...",
      "CONSULTING": "Разговор с оператором",
      "CALLER_ON_HOLD": "Звонящий на удержании",
      "BUSY": "Занято",
      "DND": "Не беспокоить",
      "UNAVAILABLE": "Недоступен",
      "REJECTED": "Звонок отклонён",
      "CALL_FAILED": "Ошибка звонка"
    },
    "QUEUES": {
      "MORE": "Другие очереди"
    }
  },
  "DIAL_REDIRECT": {
    "DIALING": "Набор номера {number}… Можно закрыть эту вкладку.",
    "NO_NUMBER": "Номер не указан. Используйте ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Введите номер телефона...",
    "ACTIONS": {
      "DIAL": "Набрать номер",
      "DIAL_FROM": "Выберите номер, с которого звоните"
    },
    "DIAL_FROM": {
      "TITLE": "Звонок с номера источника"
    },
    "VALIDATION": {
      "REQUIRED": "Введите номер телефона",
      "INVALID_FORMAT": "Неверный формат номера телефона"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Настройки и тестирование звука",
    "SELECT_DEVICE": "Выберите устройство...",
    "SYSTEM_DEFAULT": "Системное устройство по умолчанию",
    "SAVED": "Сохранено",
    "DISCONNECTED_SUFFIX": "не подключено",
    "DEVICE_DISCONNECTED": "Выбранное устройство не подключено. Звонки используют системное устройство по умолчанию, пока оно снова не подключится.",
    "MICROPHONE": {
      "TITLE": "Микрофон",
      "START_TEST": "Проверить микрофон",
      "STOP_TEST": "Остановить проверку",
      "LEVEL": "Уровень:",
      "VERDICT": {
        "LISTENING": "Скажите что-нибудь в микрофон…",
        "SILENT": "Вас не слышно. Проверьте, что микрофон включён и выбран правильный.",
        "LOW": "Вас слышно слишком тихо. Выберите другой микрофон или настройте входную громкость в системных настройках.",
        "GOOD": "Хороший звук — вас хорошо слышно."
      }
    },
    "SPEAKER": {
      "TITLE": "Динамик",
      "TEST": "Проверить динамик",
      "TESTING": "Проверка...",
      "VOLUME": "Громкость:",
      "USING_DEFAULT": "Выбранный выход недоступен — воспроизведение через системное устройство по умолчанию."
    },
    "DONE": "Готово",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Ошибка доступа к микрофону. Проверьте разрешения.",
      "MICROPHONE_PERMISSION_DENIED": "Доступ к микрофону заблокирован. Разрешите его в настройках сайта в браузере, чтобы пользоваться телефоном.",
      "MICROPHONE_SILENT": "Ваш микрофон не улавливает звук. Проверьте настройки звука.",
      "EXTENSION_REQUIRED": "Расширение телефона не обнаружено. Установите или включите его, чтобы использовать микрофон.",
      "SPEAKER_TEST": "Ошибка при проверке динамика."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Офлайн",
    "ONLINE": "Онлайн",
    "BUSY": "Занято"
  },
  "QUEUE_STATUS": {
    "READY": "Готов",
    "NOT_READY": "Не принимает звонки",
    "WRAP_UP": "Постобработка",
    "BREAK": "Перерыв",
    "LUNCH": "Обед",
    "AWAY": "Отошёл",
    "DO_NOT_DISTURB": "Не беспокоить",
    "BUSINESS_TRIP": "Командировка",
    "OTHER_CALL": "Другой звонок",
    "QUEUE_CALL": "Звонок из очереди",
    "OFFLINE": "Офлайн",
    "ONLINE": "Онлайн",
    "NO_ACCESS": "Нет телефона",
    "PARTIALLY_READY": "Частично готов",
    "MIXED": "Смешанный",
    "CHAT_ONLINE": "Онлайн (чат)",
    "CHAT_BUSY": "Занято (чат)",
    "CHAT_OFFLINE": "Офлайн (чат)"
  }
}
